import { PendingType } from './types';

export const findPendingOperation = (state: PendingType[], ...actionsToCheck: string[]): boolean =>
    state.some((action) => actionsToCheck.includes(action.type));

export const findPendingOperationWithId = (state: PendingType[], ...actionsToCheck: string[]) =>
    state.filter((action) => actionsToCheck.includes(action.type));
